import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_API_BASE_URL
const API_KEY: any = process.env.REACT_APP_API_KEY
export const GET_BROKER = `${API_URL}/v1/ekyc/broker/info`

const getBroker = async (val?: any) => {
  try {
    const response = await axios.post(GET_BROKER, val, {
      headers: {
        'x-api-key': API_KEY,
        'Access-Control-Allow-Origin': '*',
      },
    })

    return response.data
  } catch (error) {
    console.log(error)
  }
}

export default getBroker
